import InspirationProductImage from '@components/InspirationProductImage/InspirationProductImage';
import styles from '@features/cms/components/inspirations/InspirationProductGalleryMulti/InspirationProductGalleryMulti.styles';
import { IInspirationProductGalleryMulti } from '@features/cms/typescript';
import { useResponsive } from '@features/responsive';
import InspirationSlider from '@components/InspirationSlider/InspirationSlider';
import theme from '@styles/theme';
type PropsType = {
  data: IInspirationProductGalleryMulti;
  defaultBackground?: string;
};
const InspirationProductGalleryMulti = ({
  data,
  defaultBackground = theme.rawColors.neutralWhite
}: PropsType) => {
  const {
    isWiderThanTabletlg,
    isNarrowerThanMobilelg
  } = useResponsive();
  return <section id={data.code} sx={styles.inspirationMultiSection(data.background || defaultBackground)} data-testid={data.code}>
      {isWiderThanTabletlg ? data.images.map(image => <InspirationProductImage key={image.itemId} imageData={image} />) : <InspirationSlider withPagination slidesPerView={isNarrowerThanMobilelg ? 1 : 2}>
          {data.images.map(image => <InspirationProductImage key={image.itemId} imageData={image} />)}
        </InspirationSlider>}
    </section>;
};
export default InspirationProductGalleryMulti;